import { useQuery } from "@tanstack/react-query";

import api from "../apiClient";

import cookiesHelper from "../../helpers/cookies";

import { IUserVisitsReportData } from "../../interfaces/analytics";

const useGetUserVisitsReport = (filterQuery: string) => {
    const queryFn = async (): Promise<IUserVisitsReportData> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`analytics/user-visits-report?${filterQuery}`);
        return res.data;
    };

    return useQuery({
        queryKey: ['user-visits-report', filterQuery],
        queryFn,
        retry: 0,
    });
};

export default useGetUserVisitsReport;